import React from 'react';
import clsx from 'clsx';
import { TextField } from '@td-client-frontend/common';
import { CloseIcon, SearchAlternative } from '@td-client-frontend/icons';

export interface SearchTextInputProps {
  value: string;
  onChange: (value: string) => void;
  onClear?: () => void;
  placeholder?: string;
}

export const SearchTextInput = ({ value, onChange, onClear, placeholder }) => {
  return (
    <TextField
      name="search"
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      data-testid="searchtextinput-input"
      Right={
        <button
          className={clsx(
            'flex items-center px-4 self-stretch h-full focus:outline-none focus-visible:shadow-outline disabled:opacity-50',
            !value && 'bg-primary-600'
          )}
          onClick={onClear}
          aria-label="Search"
          data-testid="searchtextinput-button"
        >
          {!value ? (
            <SearchAlternative
              width={20}
              height={20}
              className="fill-white text-white"
              aria-hidden
              data-testid="searchtextinput-search-icon"
            />
          ) : (
            <CloseIcon width={18} height={18} data-testid="searchtextinput-close-icon" />
          )}
        </button>
      }
      aria-label="Search Field"
    />
  );
};
